import { render } from "./PromptList.vue?vue&type=template&id=519240d0&scoped=true&ts=true"
import script from "./PromptList.vue?vue&type=script&lang=ts"
export * from "./PromptList.vue?vue&type=script&lang=ts"

import "./PromptList.vue?vue&type=style&index=0&id=519240d0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519240d0"]])

export default __exports__